// extracted by mini-css-extract-plugin
export default {"additionalInfo":"AddInitionalInfo_additionalInfo__Nvm9B"};